<template>
  <v-layout row>
    <v-flex class="title font-weight-regular">{{ $t('CART.SHIPPING_COST') }}</v-flex>
    <v-flex class="title font-weight-regular" text-xs-right>
      <!-- If shipping is included -->
      <template v-if="cartDetails.is_delivery_included">
        <span class="body-1">{{ $t('ARTWORK.SHIPPING_INCLUDED')}}</span>
      </template>

      <template v-else>
        {{ cartDetails.delivery.amount || '-' }}
        <br />
        <span class="body-1">
          <span class="text-lowercase">({{ $t('CART.INCLUDE') }}</span>
          {{ $t('CART.VAT')}} {{ cartDetails.delivery.vat_amount }})
        </span>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
/**
 * Responsible for showing shipping cost detail into cart and checkout totals view
 */
export default {
  props: ['cartDetails']
};
</script>